import { useCallback, useState } from "react";
import { useDownloadFile } from "./useDownloadFIle";

export const useDownloadAttachment = (service: any) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { download } = useDownloadFile(setIsLoading);

  const onDownload = useCallback(
    (request: any, fileName: string): void => {
      setIsLoading(true);

      download(service, request, fileName);
    },
    [download, service]
  );

  return { isLoading, onDownload };
};
